import ShowProfile from './views/pages/show-profile';
import { Route, Switch } from 'react-router-dom';
import { routePaths } from './infrastructure/constants';
import Helmet from 'react-helmet';
import { useTranslation } from 'react-i18next';
import tapDemoPic from './views/images/tap-demo.png';
import MaintenanceScreen from './views/pages/maintenance';

// MAINTENANCE MODE: Simplified App component that only renders:
// 1. Public profile page (ShowProfile) - for sharing digital business cards
// 2. Maintenance screen - for all other routes

const App = () => {
  const { t, i18n } = useTranslation();

  return (
    <>
      <Helmet htmlAttributes={{ lang: i18n.language.substring(0, 2) }}>
        <meta name='robots' content='noindex,nofollow' />
        <title>{t('metaTagTitle')}</title>
        <meta name='title' content={t('metaTagTitle')} />
        <meta name='description' content={t('metaTagDescription')} />
        <meta property='og:type' content='website' />
        <meta property='og:url' content={window.location.pathname} />
        <meta property='og:title' content={t('metaTagTitle')} />
        <meta property='og:description' content={t('metaTagDescription')} />
        <meta property='og:image' content={tapDemoPic} />
        <meta property='twitter:card' content='summary_large_image' />
        <meta property='twitter:url' content={window.location.pathname} />
        <meta property='twitter:title' content={t('metaTagTitle')} />
        <meta property='twitter:description' content={t('metaTagDescription')} />
        <meta property='twitter:image' content={tapDemoPic} />
      </Helmet>

      <Switch>
        {/* Public profile page - still works during maintenance */}
        <Route path={routePaths.SHOWPROFILE} component={ShowProfile} />
        {/* All other routes show maintenance screen */}
        <Route component={MaintenanceScreen} />
      </Switch>
    </>
  );
};

export default App;
